<div class="pef-editor">
  @if (loadError()) {
  <p-message severity="error">{{ loadError() }}</p-message>
  } @else {
  <div class="pef-editor-content">
    @if (currentSheet().layoutType === 'settings') {
    <lib-pef-settings
      [sheet]="currentSheet()"
      [data]="mergedData()"
      [loading]="isLoading()"
      [dirtyKeys]="dirtyKeys()"
      [readonly]="readonly()"
      (cellValueChange)="onCellValueChange($event)"
    />
    } @else {
    <lib-pef-sheet
      [sheet]="currentSheet()"
      [data]="mergedData()"
      [loading]="isLoading()"
      [dirtyKeys]="dirtyKeys()"
      [readonly]="readonly()"
      (cellValueChange)="onCellValueChange($event)"
      (cellValuesChange)="onCellValuesChange($event)"
      (autofill)="onAutofill($event)"
    />
    }
  </div>

  <div class="pef-editor-toolbar">
    @if (isLoading()) {
    <p-progressbar
      mode="indeterminate"
      [style]="{ height: '3px' }"
      class="pef-editor-progress"
    />
    } @if (!readonly()) {
    <div class="pef-editor-toolbar-inner">
      <p-button
        label="Calcola"
        [severity]="hasPendingInputs() ? 'contrast' : 'secondary'"
        [disabled]="isLoading() || !hasPendingInputs()"
        (onClick)="onCalculate()"
      />
    </div>
    }
  </div>
  }
</div>
